import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { ChatMessage } from './chat-message.model';

@Injectable()
export class ChatService {
  private readonly relativeUrl = 'service-order-chats';

  constructor(private http: HttpClient) {}

  // Obter mensagens de chat associadas a uma ordem de serviço
  getMessages(serviceOrderId: string): Observable<ChatMessage[]> {
    return this.http.get<ChatMessage[]>(
      `${API_PATH}${this.relativeUrl}/${serviceOrderId}`,
      {
        headers: {
          'X-Skip-Loading': 'true'
        }
      }
    );
  }

  // Enviar mensagem de chat associada a uma ordem de serviço
  sendMessage(serviceOrderId: string, message: ChatMessage): Observable<ChatMessage> {
    if (!message.message.trim()) {
      throw new Error('A mensagem não pode estar vazia.');
    }
    return this.http.post<ChatMessage>(
      `${API_PATH}${this.relativeUrl}/${serviceOrderId}`,
      message,
      {
        headers: {
          'X-Skip-Loading': 'true'
        }
      }
    );
  }

  deleteChat(serviceOrderId: string): Observable<void> {
    return this.http.delete<void>(
      `${API_PATH}${this.relativeUrl}/${serviceOrderId}`,
      {
        headers: {
          'X-Skip-Loading': 'true'
        }
      }
    );
  }
}

